interface PlusIconProps {
  color?: string;
}

export const PlusIcon = ({color}: PlusIconProps) => {
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.125 8.5C17.125 9.04688 16.6953 9.4375 16.1875 9.4375H9.9375V15.6875C9.9375 16.2344 9.50781 16.6641 9 16.6641C8.45312 16.6641 8.0625 16.2344 8.0625 15.6875V9.4375H1.8125C1.26562 9.4375 0.875 9.04688 0.875 8.53906C0.875 7.99219 1.26562 7.5625 1.8125 7.5625H8.0625V1.3125C8.0625 0.804688 8.45312 0.414062 9 0.414062C9.50781 0.414062 9.9375 0.804688 9.9375 1.3125V7.5625H16.1875C16.6953 7.5625 17.125 7.99219 17.125 8.5Z" fill={color ?? "white"}/>
    </svg>
  )
}